export enum MoneyType {
    USDT = 1,
    ETH = 2,
    BTC = 3,
    IB = 4,
    GB = 5,
    BRL = 6,
    TRX = 7,
    JPY = 8,
    NGN = 9,
    USD = 10,
    BNB = 11,
    INR = 12,
    PHP = 13,
    TT = 14,
    IDR = 15,
    MYR = 26,
    GHC = 27,
    VND = 28,
    CAD = 29,
    MXN = 30,
    KRW = 34,
    COP = 37,
    PEN = 40,
    BONUS = 45,
    SGD = 47,
    ZAR = 65,
}

export enum CurrencyType {
    Crypto = 1,
    Fiat = 2,
    Platform = 3,
}

export enum MessageType {
    PING = 3,
    PING_REPLY = 4,
    CLOSE = 5,
    PLATFORM_MESSAGE = 6,

    PLAYER_LOGIN_REQ = 100,
    PLAYER_LOGIN_REPLY = 101,
}

export interface WindowConfig {
    base_url: string;
    image_base_url: string;
    thirdparty_image_base_url: string;
    bridge_url: string;
    promotion_url: string;
    platform_id: number;
    web_title: string;
    bridgeName: string;
    affiliateDashboard: string;
    lang: Array<string>;
    betby_library: string;
    betby_brand_id: string;
    betby_support_currency: string;
    betby_theme_dark: string;
    betby_theme_light: string;
    domain: string;
    origin: string;
    platform_currency_gb: string;
    platform_currency_ib: string;
    convertCurrencyProvider: number[];
    version: string;
    sport_type: number;
    sport_status: number;
    pingbo_support_currency: string;
    subPlatformConfig?: Record<string, {download_url: string; inviteCode: string}>;
    google_auth_client_id: string;
    image_optimized_base_url: string;
    enable_chat: boolean;
    is_enabled_chat?: boolean;
}

export interface CurrencyItem {
    tokenId: number;
    minDeposit: number;
    maxDeposit: number;
    minWithdraw: number;
    maxWithdraw: number;
    status: number;
    tokenName: string;
    categoryId: CurrencyType;
    minWithdrawGasAmount: number;
    gasWithdraw: number;
    canDeposit: number;
    canWithdraw: number;
    listOrder: number;
}

export interface VIP {
    cashbackRate: number;
    depositeAmount: number;
    exp: number;
    inviteRewards: string;
    level: number;
    name: string;
    platformId: number;
    rewards: string;
    rid: number;
    vipMonthReward: number;
    vipWeekReward: number;
    vipDailyMaxWithdrawCount: number;
    vipSingleMaxWithdrawAmount: number;
    originalsCashbackRate: number;
    slotsCashbackRate: number;
    sportsCashbackRate: number;
    liveCasinoCashbackRate: number;
    weekRewardRateMax: number;
    monthRewardRateMax: number;
}

export interface PlatformConfig {
    registerAndDepositTime: number;
    registerAndDepositRate: number;
    registerAndDepositBonusRate: number;
    vipWithdrawConfig?: {
        effectiveUserTags: string;
        isAllUserEffective: number;
    };
    affiliateRewardList: Array<{
        isDefault: number;
        platformId: number;
        rewardAmount: string;
        rewardTokenId: number;
        validLevel: number;
    }>;
    webSocketUrl: string;
    androidUrl: string;
    countryCode: string;
    currencyList: Array<CurrencyItem>;
    payProviderList: Array<{
        canDeposit: number;
        canWithdraw: number;
        minDeposit: number;
        maxDeposit: number;
        minWithdraw: number;
        maxWithdraw: number;
        providerName: string;
        tokenId: number;
        minWithdrawGasAmount: number;
        gasWithdraw: number;
        listOrder: number;
    }>;
    rewardConfig?: {
        rewardAmount: number;
        tokenId: number;
    };
    customerEmail: string;
    vipList: VIP[];
    depositEmailStatus: number;
    depositMobileStatus: number;
    withdrawEmailStatus: number;
    withdrawMobileStatus: number;
    forceBindPhoneNo: number;
    isOpenEmailRegister: number;
    isOpenMobileRegister: number;
    socialMediaList: Array<{
        name: string;
        isFeatured: number;
        isSideMenu: number;
        linkUrl: string;
        logoUrl: string;
        sortIndex: number;
    }>;
    convertedToken: Array<{tokenId: number; tokenName: string}>;
    mainToken: Array<{tokenId: number; tokenName: string}>;
    isOpenMobileLogin: number;
    isOpenEmailLogin: number;
    loginSortType: number;
    registerSortType: number;
    forceMobileVerify?: number;
    enableVipChangeRewardRate: boolean;
}

export interface Turnover {
    type: number | string;
    amount: number;
    wager: number;
}

export enum UserLoginType {
    MOBILE_LOGIN = 1,
    EMAIL_LOGIN,
    QUICK_LOGIN,
    CACHE_LOGIN,
    THIRD_TYPE_FACE_BOOK,
    THIRD_TYPE_GOOGLE,
    THIRD_TYPE_TELEGRAM,
    THIRD_TYPE_METAMASK,
    THIRD_TYPE_BEE,
}

export enum LoginType {
    HIDE = "HIDE",
    LOGIN = "login",
    REGIST = "regist",
    FORGET = "forget",
    SAFETY = "safety",
}

export const CurrencySymbol = {
    0: "$",
    1: "$",
    2: "$",
    3: "$",
    4: "$",
    5: "$",
    6: "R$", //BR
    7: "$",
    8: "￥", //JYP
    9: "₦", //NGN
    10: "$",
    11: "$",
    12: "₹", //INR
    13: "₱", //Php
    14: "$",
    15: "Rp", //IDR
    26: "RM",
    28: "₫",
    29: "C$",
    30: "$",
};

export interface AppParams {
    af_app_id: string;
    af_app_key: string;
    appsflyer_id: string;
    advertising_id: string;
    schemekey: string;
}

export enum WalletType {
    Deposit = "Deposit",
    Withdraw = "Withdraw",
    BuyCrypto = "BuyCrypto",
    Tip = "Tip",
    Hide = "Hide",
}

export enum LocalType {
    En = "en",
    Fr = "fr",
    Zh = "zh",
    Es = "es",
    Pt = "pt",
    Ko = "ko",
    Ja = "ja",
    De = "de",
    Hu = "hu",
    Tr = "tr",
    Ru = "ru",
    Vi = "vi",
}

export type TKey = string | number;
